.container {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  min-width: 27.2rem;
  height: 100%;
  padding: 1.6rem;
  background: var(--color-grayscale-eerie-black);
  border-radius: 0.4rem;
  flex: 1 1 0;

  &[data-disabled='true'] {
    background: var(--color-grayscale-eerie-black);

    h1,
    p,
    span {
      color: var(--color-grayscale-arsenic) !important;
    }

    img {
      opacity: 0.5;
    }

    svg,
    svg * {
      fill: var(--color-grayscale-arsenic);
    }
  }

  &[data-current='true'] {
    box-sizing: border-box;
    box-shadow: inset 0 0 0 2px var(--color-grayscale-tuna);
    background: var(--color-grayscale-charleston);
  }

  @media screen and (min-width: $bp-medium) {
    min-height: auto;
    height: 100%;
  }
}

.plan-container {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
}

.plan-details {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  min-height: 11rem;
}

.label {
  color: var(--color-grayscale-light-slate);
  font-weight: 400;
  letter-spacing: 0.1rem;
  margin-bottom: 0.4rem;
}

.title {
  color: var(--color-grayscale-white);
  font-size: 2.4rem;
  font-weight: 600;
}

.description {
  color: var(--color-grayscale-light-slate);
  margin-top: 1.6rem;
}

.price {
  display: flex;
  align-items: baseline;
  gap: 0.4rem;

  & > span:first-of-type {
    color: var(--color-grayscale-white);
    font-size: 2.4rem;
    font-weight: 700;
  }

  color: var(--color-grayscale-light-slate);
  font-size: 1.6rem;
  font-weight: 500;
}

.plan-information {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.information-card {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.information-text {
  color: var(--color-grayscale-light-slate);
}

.custom-price {
  & > b {
    color: var(--color-grayscale-white);
    font-size: 2.4rem;
    font-weight: 700;
  }

  color: var(--color-grayscale-light-slate);
  font-size: 1.6rem;
  font-weight: 500;
}
